import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class DIWRegistration extends TKCustomElementFactory {
    input?: HTMLInputElement;
    output?: HTMLInputElement;

    constructor() {
        super();

        this.input = this.querySelector('[data-tk-copy-input]') || undefined;
        this.output = this.querySelector('[data-tk-copy-output]') || undefined;
    }

    connectedCallback(): void {
        if (!this.input || !this.output) throw new Error('DIWRegistration: missing element');

        this.registerListener();
    }

    registerListener(): void {
        const action = this.copyValue.bind(this);
        this.pushListener({ event: 'input', element: this.input!, action });
    }

    copyValue(): void {
        this.output!.value = this.input!.value;
    }
}
